import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { TravelContainerProps } from "components/Travel/interface";
import HeaderMobile from "components/Travel/Mobile/Header";

import SubscriptionInquery from "components/Travel/Mobile/Subscription/inquery";
import SubscriptionList from "components/Travel/Mobile/Subscription/list";
import SubscriptionDetail from "components/Travel/Mobile/Subscription/detail";

const SubscriptionMobile: React.FunctionComponent<TravelContainerProps> = ({
  history,
  match
}) => {
  useEffect(() => {
    const pathArray = window.location.pathname.split("/");
    if (pathArray[pathArray.length - 1] === "subscription") {
      sessionStorage.removeItem("subscription");
    }
    return () => {
      sessionStorage.removeItem("subscription");
    };
  }, []);
  return (
    <>
      <HeaderMobile stepInfo="history" />
      <Route
        exact
        path={match.url}
        render={() => <SubscriptionInquery match={match} history={history} />}
      />
      <Route
        exact
        path={`${match.url}/list`}
        render={() => <SubscriptionList match={match} />}
      />
      <Route path={`${match.url}/list/:id`} component={SubscriptionDetail} />
    </>
  );
};

export default SubscriptionMobile;
